import './App.css';
import './assets/css/tailwind.css'
import './assets/css/materialdesignicons.min.css'
import './index.css';
import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Index from './pages';
import AboutPage from './pages/about';
import SiteTheme from './components/siteTheme';
import ProjectsIndex, { ProjectCountryPage, ProjectDetailPage } from './pages/project';
import ServicesIndex, { ServiceCategoryPage, ServiceDetailPage } from './pages/service';
import CmsPage from './pages/cmsPage';
import ContactPage from './pages/contact';
import SiteAssistant from './components/siteAssistant';

function HashScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: pathname === "/" ? "auto" : "smooth" });
      return undefined;
    }
    const id = hash.replace("#", "");
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 250);
    return () => window.clearTimeout(timer);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <>
      <HashScroll />
      <SiteTheme />
      <Routes>
        <Route path='/' element={<Index/>}/>
        <Route path='/about' element={<AboutPage/>}/>
        <Route path='/contact' element={<ContactPage/>}/>
        <Route path='/services' element={<ServicesIndex/>}/>
        <Route path='/services/category/:category' element={<ServiceCategoryPage/>}/>
        <Route path='/services/:id' element={<ServiceDetailPage/>}/>
        <Route path='/projects' element={<ProjectsIndex/>}/>
        <Route path='/projects/country/:country' element={<ProjectCountryPage/>}/>
        <Route path='/projects/:id' element={<ProjectDetailPage/>}/>
        <Route path='/pages/:slug' element={<CmsPage/>}/>
      </Routes>
      <SiteAssistant />
    </>
  );
}

export default App;
